function compare_objects(object_a, object_b) {
   return (JSON.stringify(object_a) === JSON.stringify(object_b));
}

export default compare_objects;
